<template>
  <v-card>
    <v-card-text>
      <v-btn
          @click="markAssignment()"
          class="float-right"
          color="primary lighten-1"
          small
          outlined
          :loading="loading"
      >
        Mark all as completed
      </v-btn>
    </v-card-text>
    <v-card-text class="py-0">
      <v-timeline align-top dense>
        <v-timeline-item
            v-for="(item, i) in history"
            small
            :color="item.deleted_at ? 'red' : 'primary'"
            fill-dot1
            :key="i"
        >
          <v-layout pt-1>
            <v-flex xs5 class="d-flex">
              <h4 class="timeline-title-blue">{{ item.purpose_name }}</h4>
              <span class="mx-2" style="font-size: 11px;">at</span>
              <h5 class="timeline-date ">{{ item.created_at }}</h5>
            </v-flex>
            <v-flex xs7>
              <div class="d-flex">
                <h4 class="timeline-title-blue" v-if="item.assigned_by && item.assigned_by.name">
                  {{ item.assigned_by.name }}
                </h4>
                <h3 class="timeline-title-black" style="font-size: 13px;margin-left: 3px;"
                    v-if="item.assigned_by && item.assigned_by.office">
                  ({{ item.assigned_by.office }})
                </h3>
                <v-spacer/>
                <v-btn
                    class="float-right"
                    color="red lighten-1"
                    dark
                    dense
                    text
                    v-if="item.deleted_at"
                    x-small>
                  Deleted at {{ item.deleted_at }}
                </v-btn>
                <v-tooltip top v-if="!item.deleted_at && item.status === 1 && item.assigned_by.id === user.id">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="deleteAssignment(item)"
                        class="ml-2"
                        color="red lighten-1"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>

                  </template>
                  <span>Delete Assignment</span>
                </v-tooltip>
              </div>
            </v-flex>
          </v-layout>

          <v-layout pt-1>
            <v-flex xs12>
              <div class="timeline-key">
                Forwarded For: <b>{{ item.purpose_name }}</b>
              </div>
              <div class="timeline-key">
                Assigned To:
                <b v-if="item.assignee && item.assignee.name">
                  {{ item.assignee.name }}
                </b>
              </div>
              <div class="timeline-key">
                Remarks: <b>{{ item.remarks }}</b>
              </div>
              <div class="timeline-key" v-if="!item.deleted_at">
                Status:
                <v-chip x-small class="ma-2" text-color="white" :color="item.status == 2 ? 'green' : 'red'">
                  {{ item.status == 2 ? 'Completed' : 'Pending' }}
                </v-chip>
              </div>
              <v-card class="mt-2" outlined v-if="item.extra && item.extra.acknowledgement">
                <v-card-text>
                  <div class="text-subtitle-2">Acknowledgement</div>
                  <div v-if="item.extra.acknowledgement.user.name">
                    Acknowledged by: <span class="font-weight-bold">{{ item.extra.acknowledgement.user.name }} </span>
                    <span v-if="item.extra.acknowledgement.user.office">
                      ({{ item.extra.acknowledgement.user.office }})</span>
                  </div>
                  <div v-if="item.extra.acknowledgement.created_at">
                    Acknowledged at: <span class="font-weight-bold">{{ item.extra.acknowledgement.created_at }}</span>
                  </div>
                  <div v-if="item.extra.acknowledgement.remarks">
                    Remarks : <span class="font-weight-bold">{{ item.extra.acknowledgement.remarks }}</span>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CertificationAssignmentHistory",
  props: ['history','id'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters("AuthUser", ["user"]),
  },
  methods: {
    ...mapActions("TrekkingSingle", ["forwardUser", "dropForwarded", "TrekkingMarksAsCompleted"]),
    async deleteAssignment() {
      await this.$dialog.confirm({
        text:
            "Are you sure you want to drop forwarded assignment back to previous user?",
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: async () => {
              await this.dropForwarded().then(r => {
                console.log('res', r)
              });
            },
          },
        },
      });
    },
    async markAssignment() {
      const data = {
        id: this.id,
        type: 'self-all'
      }
      await this.$dialog.confirm({
        text: "Are you sure you want to mark all assignment as completed? You cannot revert back.",
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: async () => {
              await this.TrekkingMarksAsCompleted(data).then(r => {
                console.log('res', r)
              });
            },
          },
        },
      });
    },
  }
}
</script>

<style scoped>
.timeline-title {
  color: black;
}

.timeline-title-blue {
  color: dodgerblue;
}
</style>